import ForgotPasswordPage from './ForgotPasswordPage';
import ResetPasswordPage from './ResetPasswordPage';

export default {
  ForgotPasswordPage,
  ResetPasswordPage
};
